import React, { useCallback, useEffect } from 'react';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import { NavigationDiscardChangesPrompt } from '../../../common/ui/navigation-discard-changes-prompt/index.tsx';
import { useNavigationDiscardChanges } from '../../../controllers/navigation-discard-changes/index.tsx';

export const NavigateWithoutRestorePrompt = ({
	setShouldRestore,
	isNavigationDiscardFeatureEnabled = false,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: any) => {
	const [{ deferredNavigationLink }, { setDeferredNavigationLink }] = useNavigationDiscardChanges();

	const [{ isFormDirty }] = useFormContext();

	const { push } = useRouterActions();

	const onConfirmHandler = useCallback(() => {
		setShouldRestore && setShouldRestore(false);
	}, [setShouldRestore]);

	const onCancelHandler = useCallback(() => {
		setDeferredNavigationLink('');
	}, [setDeferredNavigationLink]);

	// If the form is then we navigate immediately without showing the prompt

	useEffect(() => {
		if (deferredNavigationLink && !isFormDirty) {
			setShouldRestore && setShouldRestore(false);
			push(deferredNavigationLink);
			setDeferredNavigationLink('');
		}
	}, [deferredNavigationLink, isFormDirty, push, setDeferredNavigationLink, setShouldRestore]);

	if (!isNavigationDiscardFeatureEnabled) {
		return (
			<NavigationDiscardChangesPrompt
				navigateLink={isFormDirty ? deferredNavigationLink : ''}
				onConfirm={onConfirmHandler}
				onCancel={onCancelHandler}
			/>
		);
	}

	return <></>;
};
